import PropTypes from "prop-types";

import FormDialog from "components/modals/FormDialog";
import CustomFieldGroupForm from "./CustomFieldGroupForm";

const CustomFieldGroupModal = ({ model, open, onOpenChange, onSuccess }) => (
  <FormDialog
    FormComponent={CustomFieldGroupForm}
    model={model}
    modelType="Custom Field Group"
    open={open}
    onOpenChange={onOpenChange}
    onSuccess={onSuccess}
  />
);

CustomFieldGroupModal.propTypes = {
  model: PropTypes.object,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default CustomFieldGroupModal;
